export function getThemeColor(type = 'primary') {
    const themeElement = document.querySelector('.theme');
    return !themeElement ? 'transparent' : getComputedStyle(themeElement).getPropertyValue(`--theme-${type}-color`);
}

